import * as React from "react";

import {
  DatePicker,
  Drawer,
  Empty,
  notification,
  Skeleton,
  Form,
  Tooltip,
  Button,
  Radio,
  Select,
} from "antd";
import confirm from "antd/lib/modal/confirm";
import {
  DocumentCard,
  DocumentCardActions,
  DocumentCardActivity,
  DocumentCardDetails,
  DocumentCardTitle,
  DocumentCardType,
  MessageBar,
} from "@fluentui/react";
import { Cpu, FileText, Trash2 } from "react-feather";

import { Observer, observer } from "mobx-react-lite";
import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { toJS } from "mobx";
import moment from "moment";
import { ExclamationCircleOutlined, QuestionOutlined } from "@ant-design/icons";
import AccountStore from "../admin/accountcenter/store/accountStore";
import { getPickerDate } from "../../Utility/modules/datePicker";

const _ = require("underscore");
const { Option } = Select;
const MonthlyPerformanceStoreCtx = React.createContext(MonthlyPerformanceStore);
const { RangePicker } = DatePicker;
export const QueryListDrawer = observer(() => {
  const monthlyPerformanceStore = React.useContext(MonthlyPerformanceStoreCtx);
  const accountStore = React.useContext(AccountStore);
  const [filter, setFilter] = React.useState("daterange");
  const loadQuery = async () => {
    const start = moment(`1/1/${moment().year()}`);
    const end = moment(`12/31/${moment().year()}`);
    // console.log(start, end);
    await monthlyPerformanceStore.loadSavedQuery(start, end);
  };
  React.useEffect(() => {
    async function loadSavedQueries() {
      await loadQuery();
      await accountStore.loadAllUsers();
      console.log([...accountStore.users]);
    }
    loadSavedQueries();
  }, []);

  const TimelineItems = () => {
    const queryItems = [...monthlyPerformanceStore.savedQueryList.values()].map(
      (x) => toJS(x)
    );

    return queryItems.map((q) => (
      <DocumentCard
        aria-label="Document Card with icon. View and share files. Created by Aaron Reid a few minutes ago"
        type={DocumentCardType.compact}
        style={{ marginBottom: "10px" }}
        key={q.savedQueryId}
      >
        <DocumentCardDetails>
          <DocumentCardTitle
            shouldTruncate
            title={q.title}
            styles={{ root: { color: "red" } }}
          />
          <DocumentCardActivity
            activity={moment(q.createdOn).fromNow()}
            people={[{ name: q.author }]}
          />
        </DocumentCardDetails>
        <DocumentCardActions
          actions={[
            {
              onRenderIcon: () => (
                <Tooltip title="Run">
                  <Cpu />
                </Tooltip>
              ),
              onClick: async () => {
                try {
                  monthlyPerformanceStore.gridHeader = q?.title ?? "";
                  monthlyPerformanceStore.sqlCommand = q?.query;
                  let retVal;
                  if (q?.queryType === 1) {
                    retVal = await monthlyPerformanceStore.query();
                  } else {
                    retVal = await monthlyPerformanceStore.runAdvanceQuery();
                  }

                  if (retVal) {
                    const { displayColumns, data } = retVal;
                    console.log({
                      displayColumns,
                      data,
                    });
                    monthlyPerformanceStore.queryGrid.current.api.setColumnDefs(
                      displayColumns
                    );
                    monthlyPerformanceStore.queryResults = data;
                    /*  let idx = 0;
                    data.forEach((dataRow) => {
                      idx = idx + 1;
                      monthlyPerformanceStore.queryResults.set(idx, dataRow);
                    }); */
                    monthlyPerformanceStore.reset();
                  } else {
                    monthlyPerformanceStore.showEmpty = true;
                  }
                } catch (error) {
                  console.log(error);
                  monthlyPerformanceStore.showEmpty = true;
                  monthlyPerformanceStore.queryResults.clear();
                  const { response } = error;
                  if (response?.text) {
                    notification.error({
                      message: "SPARS Vulnerability Manager",
                      description: response?.text,
                    });
                  } else {
                    notification.error({
                      message: "SPARS Feeedback Manager",
                      description: error.message,
                    });
                  }
                }
                monthlyPerformanceStore.showQueryListDrawer = false;
              },
            },

            {
              onRenderIcon: () => (
                <Tooltip title="preview query template">
                  <FileText />
                </Tooltip>
              ),
              onClick: () => {
                monthlyPerformanceStore.selQuery = q;
                monthlyPerformanceStore.showQueryPreiviewDrawer = true;
              },
            },
            {
              onRenderIcon: () => (
                <Tooltip title="permanently delete query template ">
                  <Trash2 />
                </Tooltip>
              ),
              onClick: async () => {
                confirm({
                  icon: <QuestionOutlined />,
                  title: ` query template delete`,
                  content: (
                    <div
                      className="ms-Grid"
                      dir="ltr"
                      style={{ padding: "10px" }}
                    >
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          {`confirm ${q?.title} query template permanent trashing`}
                        </div>
                      </div>
                      <div className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12"
                          style={{ fontStyle: "italic", padding: "10px" }}
                        >
                          <ExclamationCircleOutlined style={{ color: "red" }} />{" "}
                          this operation will be logged
                        </div>
                      </div>
                    </div>
                  ),
                  onOk: async () => {
                    try {
                      const retVal = await monthlyPerformanceStore.deleteQuery(
                        q
                      );

                      monthlyPerformanceStore.savedQueryList.delete(
                        retVal.savedQueryId
                      );
                      notification.success({
                        message: "SPARS Feedback",
                        description: "query template deleted successfully",
                      });
                    } catch (error) {
                      notification.error({
                        message: "SPARS Feedback",
                        description: error.message,
                      });
                    }
                  },
                  onCancel() {
                    console.log("Cancel");
                  },
                });
              },
            },
          ]}
        />
      </DocumentCard>
    ));
  };

  return (
    <Drawer
      title={"Saved Queries"}
      visible={monthlyPerformanceStore.showQueryListDrawer}
      destroyOnClose={true}
      onClose={() => {
        monthlyPerformanceStore.showQueryListDrawer = false;
      }}
      width={"600px"}
    >
      <div className="ms-Grid" dir="ltr" style={{ paddingTop: "5px" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <MessageBar>Filter saved query templates by date</MessageBar>
          </div>
        </div>
        <div className="ms-Grid-row" style={{ paddingTop: "5px" }}>
          <div className="ms-Grid-col ms-sm9">
            {" "}
            <Form layout="vertical">
              <Radio.Group
                defaultValue="daterange"
                buttonStyle="solid"
                size="small"
                style={{ marginTop: 16 }}
                onChange={({ target }) => {
                  setFilter(target.value);
                }}
              >
                <Radio.Button value="daterange">
                  Filter By Date Range
                </Radio.Button>
                <Radio.Button value="user">Filter By User</Radio.Button>
              </Radio.Group>
              {filter === "daterange" ? (
                <Form.Item label="Filter Range:">
                  <RangePicker
                    style={{ width: "90%" }}
                    onChange={async (date, dateString) => {
                      if (date) {
                        let [startDate, endDate] = date;

                        try {
                          const start = moment(getPickerDate(startDate)).format(
                            "YYYY-MM-DDT00:00:00.000Z"
                          );
                          const end = moment(getPickerDate(endDate)).format(
                            "YYYY-MM-DDT00:00:00.000Z"
                          );

                          await monthlyPerformanceStore.loadSavedQuery(
                            start,
                            end
                          );
                        } catch (error) {
                          notification.error({
                            key: "error",
                            message: "SPARS Feedback",
                            description: error.message,
                          });
                        } finally {
                          monthlyPerformanceStore.isfiltering = false;
                        }
                      } else {
                        notification.error({
                          key: "error",
                          message: "SPARS Feedback",
                          description: "select a a valid date",
                        });
                      }
                    }}
                  />
                </Form.Item>
              ) : (
                <div className="ms-Grid-col ms-sm12">
                  <div style={{ height: "30px" }}>Filter by User:</div>
                  <Select
                    showSearch
                    style={{ width: 345 }}
                    placeholder="select an engineer"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={async (val, children) => {
                      try {
                        console.log(val, children);
                        monthlyPerformanceStore.isfiltering = true;

                        await monthlyPerformanceStore.loadSavedQueryByName(val);

                        monthlyPerformanceStore.showQueryListDrawer = true;
                      } catch (error) {
                        notification.error({
                          key: "error",
                          message: "SPARS Feedback",
                          description: error.message,
                        });
                      } finally {
                        monthlyPerformanceStore.isfiltering = false;
                      }
                    }}
                  >
                    {_.sortBy([...accountStore.users.values()], "fullName").map(
                      (u) => (
                        <Option value={u.fullName} key={u.fullName}>
                          {u.fullName}
                        </Option>
                      )
                    )}
                  </Select>
                </div>
              )}
            </Form>
          </div>

          <div className="ms-Grid-col ms-sm3">
            <Button
              type="link"
              onClick={async () => {
                await loadQuery();
              }}
            >
              Clear Filter
            </Button>
          </div>
        </div>
        {monthlyPerformanceStore.isfiltering ? (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              {" "}
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            </div>
          </div>
        ) : (
          <div className="ms-Grid-row">
            <div
              className="ms-Grid-col ms-sm12"
              style={{
                display: "flex",

                paddingTop: "30px",
              }}
            >
              {[...monthlyPerformanceStore.savedQueryList.values()].length >
              0 ? (
                <div
                  className="ms-Grid"
                  dir="ltr"
                  id="titems"
                  style={{
                    width: "100%",
                  }}
                >
                  <Observer>{TimelineItems}</Observer>
                </div>
              ) : (
                <div className="ms-Grid" dir="ltr" style={{ width: "100%" }}>
                  <div className="ms-Grid-row">
                    <div
                      className="ms-Grid-col ms-sm12"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "50vh",
                      }}
                    >
                      <Empty
                        description={`No saved query  ${
                          filter === "daterange"
                            ? " for this date range"
                            : " by the engineer"
                        }`}
                      ></Empty>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </Drawer>
  );
});

